import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const COLORS: Record<string, string> = {
  allow: 'green',
  block_pre_filter: 'red',
  block_post_filter: 'orange',
  rewrite: 'blue',
};

export function DecisionTag({ value }: { value: string | null }) {
  const { t } = useTranslation();
  if (!value) return <Tag>—</Tag>;
  return <Tag color={COLORS[value] ?? 'default'}>{t(`auditLog.decision.${value}`)}</Tag>;
}
